import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors, dimensions } from "@Constants/baseStyles"
import { groupBy } from "@Utils/utils"
import React from "react"
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native"

export const CustomRadioGroup = (props) => {
    const { handleClick, active: defaultActive } = props
    const data = props.data ?? [
        { name: "Sport", id: 1 },
        { name: "Diététique", id: 2 },
        { name: "Psycho", id: 3 },
        { name: "Médical", id: 4 }
    ]

    const Item = (props) => {
        const isActive = defaultActive && defaultActive === props.item.id
        return (
            <TouchableOpacity onPress={() => handleClick?.(props.item.id)} activeOpacity={0.7} style={{ margin: 5 }}>
                <View
                    style={{
                        ...styles.container,
                        backgroundColor: isActive ? baseColors.green.primary : baseColors.green.light
                    }}
                >
                    <OpenSansText
                        fontSize={14}
                        color={isActive ? "white" : baseColors.green.dark}
                    >{`${props.value}`}</OpenSansText>
                </View>
            </TouchableOpacity>
        )
    }

    return (
        <View style={styles.row}>
            {data.map((item, index) => (
                <Item value={item?.name?.replace("Axe", "")} item={item} key={index} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        borderRadius: 10,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        paddingVertical: 10,
        paddingHorizontal: 10
    },
    row: { alignItems: "center", justifyContent: "space-between", flexDirection: "row", flexWrap: "wrap" }
})
